import React, { useState, useEffect } from "react";
import api from "../../api"; // Ensure this path is correct based on your folder structure

const DynamicHighlightsSection = () => {
  const [highlights, setHighlights] = useState([]);
  const [sectionTitle, setSectionTitle] = useState("Highlights of Chettinad");
  const [loading, setLoading] = useState(true);

  // Helper to construct full image URL
  const getImageUrl = (path) => {
    if (!path) return "";
    // If path is already a complete URL, return it
    if (path.startsWith("http")) return path;
    // Otherwise, append to API base URL (remove trailing slash from env if needed)
    return `${process.env.REACT_APP_API_URL}/public${path}`;
  };

  useEffect(() => {
    const fetchHighlights = async () => {
      try {
        // Adjust endpoint if necessary
        const response = await api.get("/api/home-highlights"); 
        
        if (response.data && response.data.status) {
          const { data } = response.data;
          
          setHighlights(data.highlights || []);
          if (data.section_title) {
            setSectionTitle(data.section_title);
          }
        }
      } catch (error) {
        console.error("Error fetching highlights:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchHighlights();
  }, []);

  if (loading) {
    return null; // Or return a loader/skeleton if preferred
  }

  // If no data, hide section
  if (!highlights.length) {
    return null;
  }

  return (
    <section className="social-activity-area">
      <div className="sec-title text-center">
        <h2 className="mb-5">{sectionTitle}</h2>
      </div>

      <div className="container-fluid">
        <div className="choose-section">
          <div className="choose-row d-flex justify-content-center flex-wrap gap-3">
            
            {highlights.map((item) => (
              <div 
                key={item.id} 
                className={`choose-style4__single ${item.bg_class || 'bg1'}`}
              >
                <div className="content-box text-center">
                  <div className="icon-wrapper">
                    {item.icon_image && (
                      <img
                        src={getImageUrl(item.icon_image)}
                        alt={item.title}
                        className="img-fluid mb-2"
                      />
                    )}
                  </div>
                  <h3>{item.title}</h3>
                  <p>{item.subtitle}</p>
                </div>
              </div>
            ))}

          </div>
        </div>
      </div>
    </section>
  );
};

export default DynamicHighlightsSection;